import { ProfileOutlined, OneToOneOutlined, UsergroupAddOutlined } from '@ant-design/icons'
import { lazy } from 'react'
import { userTypeMap, ResourceMap } from '../utils/consts'

export const getBackgroundRoutes = (
  backgroundManage: ResourceMap['backgroundManage'],
  user: User
) => {
  const backgroundRoutes = [
    {
      path: '/background',
      resource: backgroundManage.index,
      component: require('../app/ManageLayout').default,
      routes: [
        {
          path: '/background/authManage',
          name: '权限管理',
          icon: UsergroupAddOutlined,
          resource: backgroundManage.authManage,
          routes: [
            {
              name: '用户管理',
              resource: backgroundManage.userManage,
              path: '/background/authManage/userManage',
              component: lazy(() => import('../pages/background/authManage/userManage')),
            },
            {
              name: '角色管理',
              resource: backgroundManage.roleManage,
              path: '/background/authManage/roleManage',
              component: lazy(() => import('../pages/background/authManage/roleManage')),
            },
            {
              name: '监管实体管理',
              resource: backgroundManage.entityManage,
              path: '/background/authManage/entityManage',
              component: lazy(() => import('../pages/background/authManage/entityManage')),
            },
          ],
        },
        {
          path: '/background/gaPlatform',
          name: 'GA数据平台',
          icon: ProfileOutlined,
          resource: backgroundManage.gaPlatform && !!user?.misValidated,
          routes: [
            {
              name: '数据对接管理',
              resource: backgroundManage.dataPushList,
              path: '/background/gaPlatform/dataPushList',
              component: lazy(() => import('../pages/background/gaPlatform/dataPush')),
            },
            {
              name: '备案信息管理',
              resource: backgroundManage.registerManage,
              path: '/background/gaPlatform/registerManage',
              routes: [
                {
                  name: '城市级备案',
                  resource: backgroundManage.cityRegisterManage,
                  path: '/background/gaPlatform/registerManage/city',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/registerManage/city')
                  ),
                },
                {
                  name: 'G端分区备案',
                  resource: backgroundManage.gEndRegisterManage,
                  path: '/background/gaPlatform/registerManage/gEnd',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/registerManage/gEnd')
                  ),
                },
              ],
            },
            {
              path: '/background/gaPlatform/optimize',
              name: '调优策略管理',
              resource: backgroundManage.optimizeStrategy,
              routes: [
                {
                  name: '白名单调优',
                  resource: backgroundManage.autoWhiteList,
                  path: '/background/gaPlatform/optimize/autoWhitList',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/autoWhitList')
                  ),
                },
                {
                  name: '运维力量调优',
                  resource: backgroundManage.operationOptimize,
                  path: '/background/gaPlatform/optimize/operationOptimize',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/operation')
                  ),
                },
                {
                  name: '订单调优',
                  resource: backgroundManage.virtualOrder,
                  path: '/background/gaPlatform/optimize/virtualOrder',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/virtualOrder')
                  ),
                },
                {
                  name: '虚拟定位调优',
                  resource:
                    backgroundManage.virtualPosi && user?.userType === userTypeMap.platformUser,
                  path: '/background/gaPlatform/optimize/virtualPosi',
                  routes: [
                    {
                      name: '虚拟定位配置',
                      resource: backgroundManage.virtualPosi,
                      path: '/background/gaPlatform/optimize/virtualPosi/config',
                      component: lazy(
                        () => import('../pages/background/gaPlatform/optimizeStrategy/virtualPosi')
                      ),
                    },
                    {
                      name: '调优目标配置',
                      resource: backgroundManage.areaOptimize,
                      path: '/background/gaPlatform/optimize/virtualPosi/areaOptimize',
                      component: lazy(
                        () => import('../pages/background/gaPlatform/optimizeStrategy/areaOptimize')
                      ),
                    },
                  ],
                },
                {
                  name: '蓝牙信号调优',
                  resource: backgroundManage.bluetoothConfig,
                  path: '/background/gaPlatform/optimize/bluetoothConfig',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/bluetoothConfig')
                  ),
                },
                {
                  name: 'x项目调优',
                  resource: backgroundManage.xProject,
                  path: '/background/gaPlatform/optimize/xProject',
                  routes: [
                    {
                      name: 'X项目换码任务',
                      resource: backgroundManage.xProjectConverse,
                      path: '/background/gaPlatform/optimize/xProject/convert',
                      component: lazy(
                        () =>
                          import('../pages/background/gaPlatform/optimizeStrategy/xProject/convert')
                      ),
                    },
                    {
                      name: 'X项目解绑任务',
                      resource: backgroundManage.xProjectUnbind,
                      path: '/background/gaPlatform/optimize/xProject/unbind',
                      component: lazy(
                        () =>
                          import('../pages/background/gaPlatform/optimizeStrategy/xProject/unbind')
                      ),
                    },
                  ],
                },
                {
                  name: '数字哨兵调优',
                  resource: backgroundManage.digitalGuard,
                  path: '/background/gaPlatform/optimize/digitalGuard',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/digitalGuard')
                  ),
                },
                {
                  name: '直传车数据过滤调优',
                  resource: backgroundManage.redirectDataFilter,
                  path: '/background/gaPlatform/optimize/dataFilter',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/dataFilter')
                  ),
                },
                {
                  name: '补传申诉调优',
                  resource: backgroundManage.dataSupplement,
                  path: '/background/gaPlatform/optimize/supplement',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/supplement')
                  ),
                },
                {
                  name: '入栏率调优',
                  resource: backgroundManage.parkingPointDockingRate,
                  path: '/background/gaPlatform/optimize/parkingPointDockingRate',
                  component: lazy(
                    () => import('../pages/background/gaPlatform/optimizeStrategy/dockingRate')
                  ),
                },
              ],
            },
          ],
        },
        {
          path: '/background/creditManage',
          name: '信用管理',
          icon: OneToOneOutlined,
          resource: backgroundManage.creditManage,
          routes: [
            {
              name: '骑行分开通',
              resource:
                backgroundManage.creditScoreOpen && user?.userType === userTypeMap.platformUser,
              path: '/background/creditManage/scoreOpen',
              component: lazy(() => import('../pages/background/creditManage/scoreOpen')),
            },
            {
              name: '用户白名单',
              resource: backgroundManage.creditUserWhiteList,
              path: '/background/creditManage/whiteList',
              component: lazy(() => import('../pages/background/creditManage/whiteList')),
            },
            {
              name: '用户负面清单',
              resource: backgroundManage.creditUserBannedList,
              path: '/background/creditManage/bannedList',
              component: lazy(() => import('../pages/background/creditManage/bannedList')),
            },
          ],
        },
        {
          path: '/background/reportManage/list',
          name: '汇报页面管理',
          resource: backgroundManage.reportManageList,
          icon: OneToOneOutlined,
          component: lazy(() => import('../pages/background/reportManage/reportList')),
        },
        {
          path: '/background/reportManage/detail',
          name: '汇报页详情',
          hide: true,
          resource: backgroundManage.reportManageList,
          icon: OneToOneOutlined,
          component: lazy(() => import('../pages/background/reportManage/reportDetail')),
        },
        {
          path: '/background/reportManage/edit',
          name: '汇报页编辑',
          hide: true,
          resource: backgroundManage.reportManageList,
          icon: OneToOneOutlined,
          component: lazy(() => import('../pages/background/reportManage/reportEdit')),
        },
        { path: '*', component: require('../pages/notFound').default },
      ],
    },
  ]
  return backgroundRoutes
}
